export default (message, $store, { MUTATION }) => {
  const { commit } = $store;

  commit(MUTATION.setConversationClosed, {
    chatId: message.conversation_id,
  });
};
